import LocalizedStrings from "react-localization";

let strings = new LocalizedStrings({
  en: {
    action_product_development_create_product: "Create New Product",

    label_product_development_product_name: "Product Name",
    label_prdudct_development_product_details: "Product Details",

    navigation_product_development: "Products",
    navigation_supplier_network: "Supplier Network",

    title_group_suppliers_page: "Group Suppliers",
    title_product_development_products_list_page: "Products",
    title_product_development_product_create_page: "Create New Product",

    //////////////////////////////////////////////
    ////////// LIBRARY STRING RESOURCES //////////
    //////////////////////////////////////////////

    // lib.common
    lib_common_action_cancel: "Cancel",
    lib_common_action_change_click: "Click to change",
    lib_common_action_create_new: "Create New",
    lib_common_action_delete: "Delete",
    lib_common_action_delete_confirm: "Confirm Delete",
    lib_common_action_next: "Next",
    lib_common_action_ok: "OK",
    lib_common_action_previous: "Prev",
    lib_common_action_resend: "Resend",
    lib_common_action_save: "Save",
    lib_common_action_search: "Search",
    lib_common_action_submit: "Submit",

    lib_common_daysofweek_select: "Select days of week...",
    lib_common_days_of_week_sunday: "Sunday",
    lib_common_days_of_week_sunday_short: "Sun",
    lib_common_days_of_week_monday: "Monday",
    lib_common_days_of_week_monday_short: "Mon",
    lib_common_days_of_week_tuesday: "Tuesday",
    lib_common_days_of_week_tuesday_short: "Tue",
    lib_common_days_of_week_wednesday: "Wednesday",
    lib_common_days_of_week_wednesday_short: "Wed",
    lib_common_days_of_week_thursday: "Thursday",
    lib_common_days_of_week_thursday_short: "Thu",
    lib_common_days_of_week_friday: "Friday",
    lib_common_days_of_week_friday_short: "Fri",
    lib_common_days_of_week_saturday: "Saturday",
    lib_common_days_of_week_saturday_short: "Sat",

    lib_common_instructions_account_setup_information:
      "Please fill up the information below to setup your account.",

    lib_common_label_region: "Region",
    lib_common_label_city_municipality: "City / Municipality",
    lib_common_label_barangay: "Barangay",
    lib_common_label_name: "Name",

    lib_common_placeholder_type_here: "Type here...",

    lib_common_state_error: "Something went wrong, please try again later.",
    lib_common_state_error_title: "Error",
    lib_common_state_error_server: "Error",
    lib_common_state_error_submit: "Submit Error",
    lib_common_state_error_submit_missing_fields:
      "Some required fields are missing.",
    lib_common_state_error_submit_missing_fields_details:
      "Please check and fill up all the missing fields.",

    lib_common_state_loading: "Processing, please wait...",

    lib_common_state_success: "Success",
    lib_common_state_success_copy_clipboard: "Successfully copied to clipboard",
    lib_common_state_success_update_saved:
      "Changes have been successfully saved.",

    lib_common_validation_error_required: "Please fill out this field.",

    lib_common_title_account_setup: "Finish Account Setup",
    lib_common_title_delete_confirm: "Confirm Deletion",
    lib_common_title_menu: "Menu",

    // lib.account
    lib_account_header_information_address: "Address",
    lib_account_header_information_contact: "Contact Information",
    lib_account_header_information_personal: "Name and Birthday",

    lib_account_label_address_line1: "Address Line 1",
    lib_account_label_address_line2: "Address Line 2",
    lib_account_label_birthdate: "Birthdate",
    lib_account_label_contact_landline: "Landline",
    lib_account_label_contact_mobile: "Mobile",
    lib_account_label_name_first: "First Name",
    lib_account_label_name_last: "Last Name",
    lib_account_label_name_middle: "Middle Name",

    lib_account_state_success_retrieve_account_information:
      "Successfully retrieved account information.",

    lib_account_title_account_information: "Account Information",

    // lib.authentication
    lib_authentication_action_change_password: "Change Password",
    lib_authentication_action_login: "Login",
    lib_authentication_action_logout: "Logout",
    lib_authentication_action_register: "Register",
    lib_authentication_action_resend_activation_email:
      "Resend Activation Email",
    lib_authentication_action_reset_password: "Reset Password",
    lib_authentication_action_send_reset_password_email:
      "Send reset password link",
    lib_authentication_action_send_reset_password_email_retry:
      "Retry sending email",

    lib_authentication_instruction_change_password:
      "Please fill up the following fields to change your password.",
    lib_authentication_instructions_resend_activation:
      "Please enter your email address below and we will resend the activation email.",
    lib_authentication_instruction_reset_password:
      "Please enter your email address below and we will send a link to reset your password",
    lib_authentication_instruction_reset_password_confirm:
      "Please fill up the following fields to reset your password",

    lib_authentication_label_email: "Email",
    lib_authentication_label_password: "Password",
    lib_authentication_label_password_confirm: "Confirm Password",
    lib_authentication_label_password_new: "New Password",
    lib_authentication_label_password_new_confirm: "Confirm New Password",
    lib_authentication_label_password_old: "Old Password",

    lib_authentication_redirect_existing_account:
      "Already have an account? Sign-in Here.",
    lib_authentication_redirect_login_proceed: "Proceed to login",
    lib_authentication_redirect_login_back: "Go back to login",
    lib_authentication_redirect_password_forgot: "Forgot Password?",
    lib_authentication_redirect_register:
      "Don't have an account? Register Here.",
    lib_authentication_redirect_resend_activation_link:
      "Resend activation email",

    lib_authentication_state_error_activate_account: "Account Activation Error",
    lib_authentication_state_error_activate_stale:
      "This activation link has already been used or expired",
    lib_authentication_state_error_activation_invalid:
      "this activation link is not valid",
    lib_authentication_state_error_email_activated_unregistered:
      "The following email is either already activated or unregistered.",
    lib_authentication_state_error_authentication_invalid_credentials:
      "Invalid login credentials entered or account not yet activated.",
    lib_authentication_state_error_password_confirm_password_new:
      "Confirm new password does not match new password.",
    lib_authentication_state_error_registration_confirm_password:
      "Confirm password does not match password.",
    lib_authentication_state_error_registration_email_taken:
      "This email address is already taken.",
    lib_authentication_state_error_send_reset_password_email:
      "Reset Password Error",

    lib_authentication_state_success_activate_account:
      "Account Activation Success",
    lib_authentication_state_success_activate_account_details:
      "Your account has been successfully activated.",
    lib_authentication_state_success_authenticate: "Successfully logged in.",
    lib_authentication_state_success_change_password: "Change Password Success",
    lib_authentication_state_success_change_password_details:
      "Your password has been successfully changed.",
    lib_authentication_state_success_logout: "Successfully logged out.",
    lib_authentication_state_success_register:
      "Registration success, please check your email for instructions on how to activate your account.",
    lib_authentication_state_success_register_details:
      "Account successfully created. You need to activate your account before logging in. " +
      "Please check your inbox including the spam folder.",
    lib_authentication_state_success_resend_activation_email:
      "Successfully resent activation email.",
    lib_authentication_state_success_send_reset_password_email:
      "PASSWORD RESET EMAIL SENT",
    lib_authentication_state_success_send_reset_password_email_details:
      "An email containing a link to reset your password has been sent to your email.",

    lib_authentication_state_warning_logout_localstorage:
      "Logout only occurred in localstorage.",

    lib_authentication_title_account_activation: "Account Activation",
    lib_authentication_title_change_password: "Change Password",
    lib_authentication_title_login: "Login",
    lib_authentication_title_register: "Register",
    lib_authentication_title_resend_activation: "Resend Activation Email",
    lib_authentication_title_reset_password: "Reset Password",
    lib_authentication_title_reset_password_confirm: "Confirm Reset Password",

    // lib.collaboration
    lib_collaboratoin_action_cancel_join_request: "Cancel Join Request",
    lib_collaboration_action_create_group: "Create New Virtual Office",
    lib_collaboration_action_join_group_request: "Request to Join",
    lib_collaboration_action_leave_group: "Leave Virtual Office",
    lib_collaboration_action_remove_group_member: "Remove from virtual office",
    lib_collaboration_action_transfer_ownership:
      "Transfer ownership to admin member",
    lib_collaboration_action_update_member_role_admin: "Promote to admin",
    lib_collaboration_action_update_member_role_normal:
      "Demote to normal member",
    lib_collaboration_action_view_profile_member: "View member profile",
    lib_collaboration_action_view_profile_group: "View Group Information",

    lib_collaboration_instructions_group_delete:
      "This action cannot be undone. You will lose this virtual office along " +
      "with all its files, comments, messages, etc.",
    lib_collaboration_instructions_group_delete_confirm:
      "Please type the following to confirm:",
    lib_collaboration_instructions_group_invitation:
      "You've been invited to join",
    lib_collaboration_instructions_group_join_request_delete_confirm:
      "Delete request to join",
    lib_collaboration_instructions_group_leave_owner:
      "You cannot leave the virtual office if you are the owner. " +
      "Please transfer ownership to an admin first.",

    lib_collaboration_label_group: "Virtual Office",
    lib_collaboration_label_group_plural: "Virtual Offices",
    lib_collaboration_label_group_name: "Virtual Office Name",
    lib_collaboration_label_group_description: "Virtual Office Description",
    lib_collaboration_label_group_role_admin: "ADMIN",
    lib_collaboration_label_group_role_owner: "OWNER",
    lib_collaboration_label_group_role_user: "You",
    lib_collaboration_label_group_user_join_request: "Join Request",
    lib_collaboration_label_group_user_join_request_plural: "Join Requests",
    lib_collaboration_label_group_settings: "Settings",
    lib_collaboration_label_invite_members: "Invite Members",
    lib_collaboration_label_members: "Members",
    lib_collaboration_label_requests_join_group: "Member Requests",
    lib_collaboration_label_requests_join_group_requested: "Requested",

    lib_collaboration_state_error_join_group_request_duplicate:
      "Error, you have already sent a request to join this group.",

    lib_collaboration_state_success_approve_group_join_request:
      "Successfully accepted join request.",
    lib_collaboration_state_success_create_group: "Successfully created group.",
    lib_collaboration_state_success_create_group_join_request:
      "Successfully requested to join group.",
    lib_collaboration_state_success_delete_group: "Successfully deleted group.",
    lib_collaboration_state_success_delete_request:
      "Successfully deleted request.",
    lib_collaboration_state_success_leave_group: "Successfully left group.",
    lib_collaboration_state_success_reject_group_join_request:
      "Successfully rejected join request",
    lib_collaboration_state_success_remove_group_member:
      "Successfully removed group member",
    lib_collaboration_state_succes_retrieve_group_information:
      "Successfully retrieved group information",
    lib_collaboration_state_success_retrieve_group_members:
      "Successfully retrieved group members",
    lib_collaboration_state_success_retrieve_join_requests:
      "Sucessfully retrieved join requests.",
    lib_collaboration_state_success_retrieve_joined_groups:
      "Successfully retrieved joined groups",
    lib_collaboration_state_success_transfer_ownership:
      "Successfully transferred ownership.",
    lib_collaboration_state_success_update_member_role:
      "Successfully updated member role",

    lib_collaboration_status_group_owned: "OWNED",

    lib_collaboration_title_joined_groups: "Your Virtual Offices",
    lib_collaboration_title_create_group: "Create New Virtual Office",
    lib_collaboration_title_delete_group: "Delete Virtual Office",
    lib_collaboration_title_group_home: "Dashboard",
    lib_collaboration_title_group_invitation: "Group Invitation",
    lib_collaboration_title_group_members: "Members",
    lib_collaboration_title_group_profile: "Office Profile",
    lib_collaboration_title_user_profile: "User Profile",

    // lib.file
    lib_file_action_upload: "Upload Files",

    lib_file_instructions_image_upload_single:
      "Drag an image here, or click to select an image.",
    lib_file_instructions_image_upload_multiple:
      "Drag images here, or click to select images.",

    // lib.reservation
    lib_reservation_action_reservation_create: "Create New Reservation",
    lib_reservation_action_reserve: "Reserve",

    lib_reservation_search_reservable_type: "Search reservable type...",
    lib_reservation_search_placeholder_empty:
      "No available reservable matching criteria",
    lib_reservation_search_placeholder_unsearched:
      "Please search to view available schedules",

    lib_reservation_state_success_reservable_types_retrieve:
      "Successfully retrieved reservable types.",
    lib_reservation_state_success_reservables_search:
      "Successfully searched reservables.",
    lib_reservation_state_success_reservation_create:
      "Successfully created reservation.",
    lib_reservation_state_success_reservations_retrieve:
      "Successfully retrieve reservations.",

    lib_reservation_status_schedule_available: "Available to reserve",
    lib_reservation_status_schedule_done: "This schedule is in the past",
    lib_reservation_status_schedule_unavailable:
      "This schedule is already taken",
    lib_reservation_status_schedules_empty:
      "There are no schedules available for this day",

    lib_reservation_title_reservables_search: "Search Schedules",
    lib_reservation_title_reservations: "Reservations",
    lib_reservation_title_reservation_notif: "Upcoming Reservation",
  },
});

export default strings;
